import * as React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbTableTBody } from '@celebration/design-system/dist/lib/table-tbody';

export default createComponent({
    react: React,
    elementClass: ClbTableTBody,
    tagName: ClbTableTBody.tagName,
    events: ClbTableTBody.events,
});
